import { useHistory } from "react-router-dom";
import { getUrlParamsAsObject } from "@tootools/http-utils";
import { useProject } from "@radarly/core/project/context";
import { InsightPage } from "@radarly/models/insight-pages/model";
import { IRouterService } from "@radarly/shared/router";
import { Page } from "@radarly/shared/router/pages";

export function useWizardEditorIO(router: IRouterService) {
  const project = useProject();
  const history = useHistory();
  const paramsURL = getUrlParamsAsObject(["search", "searchWorkspaceId"]);

  function goToInsightPageList() {
    history.push(
      router.getProjectUrlFromPage(project, Page.insightPagesHome, {
        ...paramsURL,
      })
    );
  }
  function goToInsightPage(page: InsightPage) {
    history.push(
      router.getProjectUrlFromPage(project, Page.insightPagesGlobalPage, {
        ...paramsURL,
        page: page.id,
      })
    );
  }
  return { goToInsightPageList, goToInsightPage };
}
